import { SET_UNIT_FEATURES } from '../reducers/unitFeatures';

export const acSetUnitFeatures = (data) => ({
  type: SET_UNIT_FEATURES,
  payload: data,
});
